<template>
  <div v-if="canView" class="card">
    <div class="card-header">
      <i class="icon-phone"></i>Allo
      <div class="pull-right form-inline">
        <label class="pr-1" for="">Depuis le</label>
        <datepicker
          v-model="untilDate"
          format="dd.MM.yyyy"
          language="fr"
          input-class="form-control"
          @input="fetchCalls()"
        ></datepicker>
      </div>
    </div>
    <div class="card-block">
      <Loader v-if="isLoading" :isVisible="isLoading" size="small" />
      <el-table
        v-else
        :data="calls"
        :default-sort="{ prop: 'date', order: 'descending' }"
        max-height="600"
      >
        <el-table-column label="Statut" width="140" prop="result" sortable>
          <template slot-scope="scope">
            <AlloCallState
              :direction="scope.row.direction"
              :result="scope.row.result"
            />
          </template>
        </el-table-column>
        <el-table-column label="Date" width="180" prop="date" sortable>
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.date) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Utilisateur"
          width="180"
          prop="user.name"
          sortable
        >
          <template slot-scope="scope">
            <template v-if="scope.row.user">
              <span
                v-if="getCommercialData(scope.row.user)"
                class="badge"
                :style="`background-color: ${
                  getCommercialData(scope.row.user).color || '#292b2c'
                }`"
              >
                {{
                  getCommercialData(scope.row.user).pseudo ||
                  scope.row.user.name
                }}
              </span>
              <span v-else>
                {{ scope.row.user.name }}
              </span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          label="Enregistrement"
          width="auto"
          prop="duration"
          sortable
        >
          <template slot-scope="scope">
            <audio
              controls
              v-if="scope.row.recording_url"
              :src="scope.row.recording_url"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import AlloCallState from "@/components/utils/AlloCallState";
import Loader from "@/components/utils/Loader";

export default {
  components: {
    Datepicker,
    AlloCallState,
    Loader,
  },

  props: {
    canView: {
      type: Boolean,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
    onlyCommercial: {
      type: Boolean,
      default: false,
    },
    onlyManager: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: false,
      untilDate: undefined,
      calls: [],
      commercials: [],
    };
  },

  async created() {
    this.untilDate = moment().subtract(1, "months").toDate();

    if (this.onlyCommercial) {
      await this.fetchCalls("clients");
    } else if (this.onlyManager) {
      await this.fetchCalls("users");
    }

    await this.fetchCommercials();
  },

  methods: {
    async fetchCalls(type) {
      try {
        this.isLoading = true;

        const { data } = await this.$api.get(`/allo/${type}-calls`, {
          params: {
            email: this.email,
            untilDate: this.untilDate,
          },
        });

        this.calls = data;
      } catch (e) {
        this.$toast.error(
          "Une erreur est survenue lors de la récupération des appels",
          e,
        );
      } finally {
        this.isLoading = false;
      }
    },

    async fetchCommercials() {
      let commercials = [];

      for (const call of this.calls) {
        if (call.user?.email && !commercials.includes(call.user.email)) {
          commercials.push(call.user.email);
        }
      }

      if (commercials.length > 0) {
        const { data } = await this.$api.get("/users/commercials/search", {
          params: {
            commercials,
          },
        });

        this.commercials = data;
      }
    },

    getCommercialData(alloUser) {
      const commercial = this.commercials.find(
        (com) => com.email === alloUser.email,
      );

      return commercial?.commercial;
    },
  },
};
</script>
